import{CharacteristicModel} from '../GlobalRegistry/CharacteristicsModel';

export class SampPointSearchFields {
  SamplingPointId: number;
  Name: string; 
  PageNo: number;  
  PageSize: number;
}
export class EquipmentSearchFields {
  EquipmentId: number;
  Name: string; 
  PageNo: number;  
  PageSize: number;
}
export class ComponentSearchFields {
  ComponentId: number;
  Name: string; 
  PageNo: number;  
  PageSize: number;
}
export class SampleCollectionEngrSearchFields{
  SampleCollectionEngineerId:number;
  Name: string; 
  PageNo: number;  
  PageSize: number;
}
export class SpIdSearchFields {
  SpidId:number;
  SpidNumber: string;
  CustomerId:number;
  EquipmentName:string;
  SamplingPointId:number;
  PageNo: number;  
  PageSize: number;
  IsForExcel:boolean;
}
export class SpIdAddModel{
  SpId:number;
  lstSpIdChars:CharacteristicModel[]
}
export class SamplingPointsModel {
  SamplingPointId: number;
  Name:string;  
}
export class EquipmentModel {
  EquipmentId: number;
  Name:string;  
}
export class AreaModel {
  AreaId: number;
  Name:string;  
}
